// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JyllQORWSegkBXP9vEmU{flex-grow:1;margin-left:16px;display:flex;position:relative}.cGrn3XDw9KwTsi3ETE66 a{color:var(--content-brand-primary);cursor:pointer;font-weight:500;text-decoration:none}.cGrn3XDw9KwTsi3ETE66 a:hover{color:var(--content-brand-secondary);text-decoration:underline}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapTable": `JyllQORWSegkBXP9vEmU`,
	"link": `cGrn3XDw9KwTsi3ETE66`
};
export default ___CSS_LOADER_EXPORT___;
